import _ from 'lodash';
import pluralize from 'pluralize';

export function isEmptyString(str) {
  return !str || str.length === 0;
}

export function toLowerCaseIfString(data) {
  // If data is a string, then lowercase the data and return the result.
  // Otherwise, return the original data.
  if (data && typeof data === 'string') {
    return _.toLower(data);
  }

  return data;
}

export function truncateAndToLowerCase(str, patterns, maxlength) {
  const newStr = _.truncate(_.replace(str, patterns, ''), {
    length: maxlength,
    omission: '',
  });
  return _.toLower(newStr);
}

export const capitalizeFirstLetter = str =>
  `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

export const removeWhitespace = str => (str ? str.replace(/\s+/g, '') : str);

/**
 * Pluralize the given text passed to it
 * @param {string} text
 * @param {number} count
 * @param {boolean} defaultToPlural Whether count <1 should return pluralized text or empty string
 * @return {string}
 */
export function pluralizeText(text, count, defaultToPlural = false) {
  if (!defaultToPlural && count < 1) return '';

  return pluralize(text, count);
}

/**
 * Count the number of decimal places in a number string.
 */
export function countDecimals(text) {
  const split = text ? text.split('.') : null;
  const decimals = split && split.length > 0 ? split[1] : null;
  return decimals ? decimals.length : 0;
}

/**
 * Capitalizes first character of multiple words within a string.
 */
export const capitalizeWords = text =>
  _.words(text).reduce((acc, word) => {
    const capitalized = _.capitalize(word);
    return acc ? `${acc} ${capitalized}` : capitalized;
  }, null);

export const renderName = (
  { firstName, middleName, lastName },
  defaultValue = '?',
) => {
  const firstMiddleName = `${firstName || ''}${
    firstName && middleName ? ' ' : ''
  }${middleName || ''}`;

  if (firstMiddleName) {
    return `${firstMiddleName}${firstMiddleName && lastName ? ' ' : ''}${
      lastName || ''
    }`;
  }

  return lastName || defaultValue;
};

const renderWalletAddress = str => {
  const start = str.substring(0, 17);
  const end = str.substring(str.length - 4);
  return `${start}...${end}`;
};

export const STRING_HELPERS = {
  pluralise: pluralizeText,
  renderWalletAddress,
};

export const STRING_ADDITIONS = {
  isEmptyString,
  truncateAndToLowerCase,
  removeWhitespace,
  pluralizeText,
  countDecimals,
  capitalizeWords,
  renderName,
  capitalizeFirstLetter,
};

export default STRING_ADDITIONS;
